import { InjectionToken } from "@angular/core";
import { ISignalRConfig } from "@app/core/signalR/signalr-config.interface";

export const NOTIFY_HUB_CONFIG = new InjectionToken<ISignalRConfig>('NOTIFY_HUB_CONFIG');
